import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Card,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";

const ReportNotification = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetch("https://ehr.kaizendigital.ai/api/dev3/getreport")
      .then((response) => response.json())
      .then((data) => setRows(data))
      .catch((error) => console.error("Error:", error));
  }, []);

  // Handle view button click
  const handleViewClick = (id) => {
    navigate("/dashboard/view-issue-status", { state: { id } });
  };

  // Handle edit button click
  const handleEditClick = (id) => {
    navigate("/dashboard/edit-issue-status", { state: { id } });
  };

  return (
    <>
      <Typography variant="h3" sx={{ mb: 2 }} color="primary">
        Notifications
      </Typography>
      <Card component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No.</TableCell>
              <TableCell>Issue Raised by (uid, uname)</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Received Date</TableCell>
              <TableCell>Action(s)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.u_id}</TableCell>
                <TableCell>{row.u_role}</TableCell>
                <TableCell>Received</TableCell>
                <TableCell>{row.issue_date}</TableCell>
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => handleViewClick(row.id)} // Pass the id here
                  >
                    <VisibilityIcon />
                  </IconButton>
                  <IconButton
                    color="primary"
                    onClick={() => handleEditClick(row.id)} // Pass the id here
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </>
  );
};

export default ReportNotification;
